import { FunctionComponent } from 'react'
import { Daycare } from '@/types/Daycare'
import profileStyles from '../DaycareProfileHandler.module.scss'
import MailSignature from './mailSignature/mailSignature'
import DaycareUrl from './daycareUrl/daycareUrl'
import PredefinedMessageList from './predefinedMessage/predefinedMessageList.tsx'

interface CustomisationProps {
    daycare: Daycare
}

const Customisation: FunctionComponent<CustomisationProps> = ({ daycare }: CustomisationProps) => {
    return (
        <div className={profileStyles.PagePosition}>
            <MailSignature daycare={daycare} />
            <PredefinedMessageList daycare={daycare} />
            <DaycareUrl daycareId={daycare.id} />
        </div>
    )
}

export default Customisation
